import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractEffects } from '../../../shared/abstract.effects';
import { GetCustomer } from '../actions/customer.actions';
import {
    DeleteCard,
    DeleteCardFailure, DeleteCardSuccess,
    ECardsActions,
    GetCards,
    GetCardsFailure,
    GetCardsSuccess
} from '../actions/cards.actions';
import { CardInterface } from '../../models/card.interface';
import { PartnerPaymentService } from '../../../shared/services/partner-payment.service';

@Injectable()
export class CardsEffects extends AbstractEffects {

    constructor(
        private actions: Actions,
        private partnerPaymentService: PartnerPaymentService,
        public override store: Store<any>
    ) {
        super(store);
    }

    paymentMethodId: string;
    password: string;

    getCards = createEffect(() => this.actions.pipe(
        ofType<GetCards>(ECardsActions.GetCards),
        switchMap(() => this.partnerPaymentService.getCards()),
        switchMap((response: Array<CardInterface>) => of(new GetCardsSuccess(response))),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new GetCards());
            } else {
                this.DisplayMessage('error_with_retry', 400, new GetCardsFailure());
                this.store.dispatch(new GetCustomer());
            }
            return throwError(error);
        })
    ));

    deleteCard = createEffect(() => this.actions.pipe(
        ofType<DeleteCard>(ECardsActions.DeleteCard),
        tap(params => {
            this.paymentMethodId = params.paymentMethodId;
            this.password = params.password;
        }),
        switchMap(() => this.partnerPaymentService.deleteCard(this.paymentMethodId, this.password)),
        switchMap(() => of(new DeleteCardSuccess(this.paymentMethodId))),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new DeleteCard(this.paymentMethodId, this.password));
            } else {
                this.DisplayMessage('error_with_retry', 400, new DeleteCardFailure());
            }
            return throwError(error);
        })
    ));
}
